import { Component, Input } from '@angular/core';
import {CommonModule} from "@angular/common";

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    imports: [
        CommonModule
    ]
})
export class SpinnerComponent {
  @Input() show: boolean = false;
  @Input() public showOverContent: boolean = false;
}
